import { render, staticRenderFns } from "./SummaryVehicleOutsideGeofence.vue?vue&type=template&id=afac9798&"
import script from "./SummaryVehicleOutsideGeofence.vue?vue&type=script&lang=js&"
export * from "./SummaryVehicleOutsideGeofence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports